import React from 'react';
import "../styles/WhyPTS.css"; 

const WhyPTS = () => {
  const features = [
    'Certified Accuracy',
    'Affordable Pricing',
    'Multilingual Expertise',
    'Confidential & Secure'
  ];

  return (
    <section id="why-pts" className="why-pts section">
      <h2>Why PTS</h2>
      <h3>Perfect Translation Services</h3>
      <p>We provide top-notch translation services with a focus on quality and customer satisfaction.</p>
      <div className="features">
        {features.map((feature, index) => (
          <div key={index} className="feature-box">{feature}</div>
        ))}
      </div>
    </section>
  );
};

export default WhyPTS;